import React, { useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import Header from "../../Common/header";
import Footer from "../../Common/footer";
import { getUserSession } from "../../Common/lib/Session";
import sendEmail from "../../Common/email/sendEmail";
import StepsNavbar from './Components/stepsNavbar';
import { HiInformationCircle } from "react-icons/hi";

export default function SubmitProject(props) {
  const projectData = props.projectData;
  const setProjectData = props.setProjectData;
  const [, forceUpdate] = useState();
  const simpleValidator = useRef(new SimpleReactValidator());

  /**
   * Checks if all fields are valid. If all fields are valid, it calls the nextPage() function to move to the next page,
   * calls createProjects function which handles the upload of the project, and calls function to send an email. 
   * If there are invalid fields, it displays the validation messages for the invalid fields and scrolls to the top.
   * @param {*} e Event object
   */
  function next(e) {
    if (simpleValidator.current.allValid()) {
      props.createProjects();
      props.nextPage(); //next page is acknowledgement
      // sendMail();
    } else {
      simpleValidator.current.showMessages();
      // rerender to show messages for the first time
      forceUpdate(1);
    }
  };

  /**
   * Moves the user to the previous page
   * @param {*} e Event object
   */
  function previous(e) {
    e.preventDefault();
    props.previousPage();
  };

  function sendMail() {
    ///USED TO SEND THE CONFIRMATION EMAIL WHEN A NEW DATASET IS UPLOAD.
    let sessionPromise = getUserSession();
    sessionPromise.then((res) => {
      if (res.success) {
        // sendEmail(params);
      }
    });
  };

  function handleTermsOfConditions() {
    setProjectData((prevState) => ({
      ...prevState,
      TermsOfConditions: !projectData.TermsOfConditions,
    }));
  };

  function handleOcapCareDeclaration() {
    setProjectData((prevState) => ({
      ...prevState,
      ocapCareDeclaration: !projectData.ocapCareDeclaration,
    }));
  };

  return (
    <>
      <Header />

      <StepsNavbar currentStep={props.step} setStep={props.setStep} next={next}/>

      <div className="overflow-auto dark:bg-gray-900">

      {projectData.errors === true && (

        <div className=" flex m-auto px-20 py-6 mt-8 rounded-md bg-red-50 w-1/2">
          <div className="flex-shrink-0">
            <svg
              className="h-5 w-5 text-red-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-red-800">
              {projectData.message}
            </h3>
          </div>
        </div>

      )}
      <form className=" max-w-2xl my-8 sm:my-12 m-auto dark:bg-gray-800 border dark:border-gray-700">
        <div className="bg-gray-100 dark:bg-gray-800 border dark:border-gray-700">
          <div>
            <div>
              <h2 className="text-center font-bold text-gray-900 sm:text-xl sm:tracking-tight lg:text-3xl py-6 border-b-2 dark:border-gray-600 dark:text-gray-100">
                Submit Project
              </h2>
            </div>
          </div>

          <div className="md:col-span-2 py-8 px-8">
            <div className="">
              <div className="rounded-md bg-blue-100 p-4 mb-4 dark:bg-gray-900">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <HiInformationCircle className="h-5 w-5 text-blue-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3">
                    {/* <h3 className="text-sm font-medium text-blue-600">Please note,</h3> */}
                    <div className="text-sm text-blue-600 leading-6">
                      By browsing, visiting or otherwise interacting with the Site,
                      you accept and agree to be bound and comply with these Terms
                      and our Privacy Policy, found at{" "}
                      <a
                        href="/terms-and-conditions"
                        className="text-blue-600 font-bold underline"
                        target="_blank"
                      >
                        Terms
                      </a>{" "}
                      and{" "}
                      <a
                        href="/privacy-policy"
                        className="text-blue-600 font-bold underline"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                      , incorporated herein by reference. If you do not agree to
                      these Terms or the Privacy Policy, you must not access or use
                      the Site.
                    </div>
                  </div>
                </div>
              </div>
              <div className="mmd:py-4 flex justify-center">
                <label className="text-gray-700 flex items-center dark:text-gray-400">
                  <input
                    type="checkbox"
                    checked={projectData.TermsOfConditions}
                    value={projectData.TermsOfConditions}
                    className="mr-2 h-4 w-4 border-gray-300 rounded text-blue-700 focus:ring-blue-700"
                    data-cy="terms"
                    onChange={handleTermsOfConditions}
                  />
                  Accept Terms and Conditions
                </label>
                <span className="text-red-600 font-bold border-red-200">
                  *
                </span>
              </div>
            </div>
            {simpleValidator.current.message(
              "Terms and Conditions",
              projectData.TermsOfConditions,
              "required|accepted",
              {
                className: "text-red-600 mt-2 text-sm text-center",
              }
            )}

            <div className="mmd:py-4 flex justify-center mt-6">
              <label className="text-gray-700 flex items-center dark:text-gray-400">
                <input
                  type="checkbox"
                  checked={projectData.ocapCareDeclaration}
                  value={projectData.ocapCareDeclaration}
                  className="mr-2 h-4 w-4 border-gray-300 rounded text-blue-700 focus:ring-blue-700"
                  data-cy="ocap-care"
                  onChange={handleOcapCareDeclaration}
                />
                This submission does not infringe on the principles of OCAP® and CARE.
              </label>
              <span className="text-red-600 font-bold border-red-200">
                *
              </span>
            </div>
            {simpleValidator.current.message(
              "OCAP CARE Declaration",
              projectData.ocapCareDeclaration,
              "required|accepted",
              {
                className: "text-red-600 mt-2 text-sm text-center",
              }
            )}
          </div>
        </div>
      </form>

      <div className="flex justify-center mb-12">
        <button
          type="submit"
          className="msm:mr-8 mr-40 py-4 px-11 border rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={(e) => previous(e)}
        >
          Previous
        </button>

        <button
          type="submit"
          onClick={(e) => next(e)}
          data-cy="next"
          className="flex justify-center py-4 px-14 border rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Submit
        </button>
      </div>
      </div>
      <Footer />
    </>
  );
}